import React from 'react';

export const Lifestyle = () => {
  return (
    <section className="py-20 md:py-32 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            {/* Left: Image */}
            <div className="order-2 lg:order-1">
              <div className="rounded-lg overflow-hidden shadow-2xl">
                <img
                  src="https://customer-assets.emergentagent.com/job_coastal-leitrim/artifacts/r4uyzazu_Sunset.jpeg"
                  alt="Peaceful coastal sunset views from The Tullaghan Pod"
                  loading="lazy"
                  decoding="async"
                  className="w-full h-[500px] object-cover"
                />
              </div>
            </div>

            {/* Right: Content */}
            <div className="order-1 lg:order-2 space-y-8">
              <h2 className="text-4xl md:text-5xl font-light text-[#071936] leading-tight">
                A Slower Side of Ireland
              </h2>

              <div className="space-y-4 text-xl text-[#1F2937] leading-relaxed">
                <p>Quiet mornings.</p>
                <p>Atlantic air.</p>
                <p>Beach walks.</p>
                <p>Evenings in the hot tub under open skies.</p>
              </div>

              <p className="text-lg text-[#6B7280] leading-relaxed pt-4">
                The Tullaghan Pod is a place to slow down and enjoy the simple things.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
